module.exports = __webpack_public_path__ + "img/empty-collect@3x.0bcd3a98.png";